import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';


const Select = ( { label, db, value, options, bucket, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ v, setV ] = useState( '' );
    const [ plist, setPicklist ] = useState( [] );

    useEffect( () => {
        if ( options && options[db] ) {
            // const list = options[db].filter( f => {
            //     if ( !f.bucket ) {
            //         return true;
            //     }
            //     return ( f.bucket === bucket );
            // } );
            // setPicklist( list );

            setPicklist( options[db] );
        }
    }, [ options, db, bucket ] );

    useEffect( () => {
        if ( value ) {
            setV( value );
        }
    }, [ value ] );

    const handleDraft = ( e ) => {
        setV( e.target.value );
        setDraftValues( prevState => (
            {
                ...prevState,
                // [e.target.id]: e.target.value
                [db]: e.target.value
            }
        ) );
    }

    return (
        <Col className='tf-obj-data-element'>
            <Form.Group as={Row} className='tf-form-group align-items-center' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col xs='auto' className='tf-form-select-field me-1'>
                    <Form.Select size='sm' className='tf-modal-select-input' value={v} onChange={handleDraft}>
                        <option>Not Set</option>
                        {
                            plist.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                        }
                    </Form.Select>
                </Col>
            </Form.Group>
        </Col>
    )
}

export default Select;